import React, { createContext, useState, useEffect, useLayoutEffect } from 'react'
import '../styles/_abstracts.scss';

export const ThemeContext = createContext()

const ThemeContextProvider = (props) => {
    const [theme, setTheme] = useState(() => {
        const localData = localStorage.getItem('theme');
        return localData ? JSON.parse(localData) : ({ chosenFontSize: '14.75pt', })
    })

    useEffect(() => {
        localStorage.setItem('theme', JSON.stringify(theme));
    }, [theme])

    useLayoutEffect(() => {
        let { chosenFontSize } = theme;
        document.documentElement.style.setProperty(`$font-size`, `${chosenFontSize}`);
    }, [theme]);

    const changeFontTheme = value => {
        setTheme({ ...theme, chosenFontSize: value });
    }

    console.log(theme.chosenFontSize)

    return (
        <ThemeContext.Provider value={{ theme, changeFont: changeFontTheme }}>
            {props.children}
        </ThemeContext.Provider >
    )
}

export default ThemeContextProvider